module.exports = __webpack_public_path__ + "img/03ed0ac.png";